// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b3656a54","938":"10cd0e94"}[chunkId] + ".chunk.js";
};